<template>
    <div class="sidebar-detail">
        <!-- :title="`${detailInfo.name || '----' } ${qrCode}`" -->
        <detail-header
            v-if="detailInfo"
            title="Palm"
            @refreshDetailPage="refreshDetailPage"
            @closeDetailPage="closeDetailPage"
        />

        <div>
            <p class="detail-title">Details</p>
            <div>
                <table class="recording-detail-table">
                    <tr>
                        <td>Id</td>
                        <td>{{ detailInfo.id }}</td>
                    </tr>
                    <tr>
                        <td>QR Code</td>
                        <td>{{ qrCode }}</td>
                    </tr>
                    <tr>
                        <td>Trial/Palm(Progeny)</td>
                        <td>
                            <mpob-palm-format :cell="detailInfo" />
                        </td>
                    </tr>
                    <tr>
                        <td>Germplasm</td>
                        <td>{{ (detailInfo.germplasm||{}).externalCode || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Fruit Type</td>
                        <td>{{ (detailInfo.fruitType||{}).name || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Fruit Colour</td>
                        <td>{{ (detailInfo.fruitColor||{}).name || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Fruit Off Type</td>
                        <td>{{ (detailInfo.fruitOffType||{}).name || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Replicate Number</td>
                        <td>{{ detailInfo.repNumber || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Plot Number</td>
                        <td>{{ detailInfo.plotNumber || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Coordinates</td>
                        <td>{{ detailInfo.coordinates || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Palm Status</td>
                        <td>{{ (detailInfo.palmStatus||{}).name || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Palm Characteristic</td>
                        <td>{{ (detailInfo.palmCharacteristic||{}).name || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Palm Classification</td>
                        <td>{{ (detailInfo.palmClassification||{}).name || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Palm Description</td>
                        <td>{{ (detailInfo.palmDescription||{}).name || "-" }}</td>
                    </tr>
                    <!-- <tr>
                        <td>Palm Generation</td>
                        <td>{{ (detailInfo.palmGeneration||{}).name || "-" }}</td>
                    </tr> -->
                    <!-- <tr>
                        <td>Palm Origin Material</td>
                        <td>{{ (detailInfo.palmOriginMaterial||{}).name || "-" }}</td>
                    </tr> -->
                    <tr>
                        <td>Standard Cross</td>
                        <td>{{ ((detailInfo.progeny||{}).crossType||{}).isStandardCross || "-" }}</td>
                    </tr>

                    <tr>
                        <td class="table-section" colspan="2">Progeny</td>
                    </tr>
                    <tr>
                        <td>Cross Type</td>
                        <td>{{ ((detailInfo.progeny||{}).crossType||{}).name || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Female Palm</td>
                        <td>
                            <mpob-palm-format class="parent-palm-info" :cell="(detailInfo.progeny||{}).maternalPalm" />
                        </td>
                    </tr>
                    <tr>
                        <td>Female Palm Fruit Type</td>
                        <td>{{ maternalFuitType || "-" }}</td>
                    </tr>
                    <tr>
                        <td>Male Palm</td>
                        <td>
                            <mpob-palm-format class="parent-palm-info" :cell="(detailInfo.progeny||{}).paternalPalm" /> 
                        </td>
                    </tr>
                    <tr>
                        <td>Male Palm Fruit Type</td>
                        <td>{{ paternalFuitType || "-" }}</td>
                    </tr>
                </table>
            </div>

            <p class="detail-title detail-title-pd">Date Time</p>
            <div class="user-datetime-container">
                <table>
                    <tr>
                        <td>Modified</td>
                        <td>{{ $_getDateTimeFormat(detailInfo.lastModificationTime) }} {{ $t('detail.by') }} {{ (detailInfo.lastModifierUser||{}).userName || '-' }}</td>
                    </tr>
                    <tr>
                        <td>Created</td>
                        <td>{{ $_getDateTimeFormat(detailInfo.creationTime) }} {{ $t('detail.by') }} {{ (detailInfo.creatorUser||{}).userName || '-' }}</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import DetailHeader from "./DetailHeader";
import { palmGet } from "@/api/palm";
import MPOBPalmFormat from "@/components/Progeny/MPOBPalmFormat";

export default {
    components: {
        "detail-header": DetailHeader,
        "mpob-palm-format": MPOBPalmFormat
    },
    props: {
        infoSidebarId: {
            type: Number | String
        }
    },
    data() {
        return {
            detailInfo: null
        };
    },
    computed: {
        qrCode() {
            return this.detailInfo.qrCode ? `${this.detailInfo?.qrCode?.code}` : "";
        },
        maternalFuitType() {
            return this.detailInfo?.progeny?.maternalPalm?.fruitType?.name;
        },
        paternalFuitType() {
            return this.detailInfo?.progeny?.paternalPalm?.fruitType?.name;
        }
    },  
    watch: {
        infoSidebarId: {
            immediate: true,
            handler() {
                this.getDetails();
            },
        }
    },
    methods: {
        async getDetails() {
            if (this.infoSidebarId) {
                var res = await palmGet({ Id: this.infoSidebarId });
                if (res) {
                    this.detailInfo = res;
                }
            }
        },
        refreshDetailPage() {
            this.getDetails();
        },
        closeDetailPage() {
            this.$store.dispatch("info_sidebar/setInfoSidebar");
        }
    }
};
</script>

<style scoped>
.stepper-container {
    padding: var(--space-16) 0;
}
.parent-palm-info {
    display: block;
}
</style>


// WEBPACK FOOTER //
// src/components/SidebarDetail/PalmSidebar.vue